var render, staticRenderFns
import script from "./Parser.vue?vue&type=script&lang=js&"
export * from "./Parser.vue?vue&type=script&lang=js&"
import style0 from "./Parser.vue?vue&type=style&index=0&id=0c98d0cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c98d0cf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\CompanyProject\\HF-IM-electron-workbench\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c98d0cf')) {
      api.createRecord('0c98d0cf', component.options)
    } else {
      api.reload('0c98d0cf', component.options)
    }
    
  }
}
component.options.__file = "src/components/parser/Parser.vue"
export default component.exports